define('GameDayCore/GDModel/ValueObjects/Scoreboard/Miniscoreboard/GameMiniscoreboard',['require','exports','module','../../ValueObjectFactory','extant/extant','./GameMiniscoreboardOffense','./GameMiniscoreboardOffense'],function(require, exports, module) {
	var VO = require('../../ValueObjectFactory'),
        exists = require("extant/extant");

	VO.create(GameMiniscoreboard);

	function GameMiniscoreboard($data) {
		var vo = VO.ensureVO(this, GameMiniscoreboard),
			data = $data;

		vo.id = data.gameday || "";
		vo.double_header_sw = data.double_header_sw || "";
		vo.home_games_back = data.home_games_back || "";
		vo.away_games_back = data.away_games_back || "";
		vo.away_games_back_wildcard = data.away_games_back_wildcard || "";
		vo.home_games_back_wildcard = data.home_games_back_wildcard || "";
		vo.game_status = data.game_status;
		vo.post_game = parsePostGame(data.post_game);
		vo.home_runs = parseHomeRuns(data.home_runs);
	}

	function parseGameStatus($state) {
		var state = $state;
		return {
			status: state.status,
			status_ind: state.status_ind,
			delay_reason: state.dealy_reason,
			inning: state.inning,
			top_inning: state.top_inning,
			b: state.b,
			s: state.s,
			o: state.o,
			inning_state: state.inning_state
		}
	}

	function parsePostGame($game) {
		var game = $game,
			GameMiniscoreboardOffense = require('./GameMiniscoreboardOffense');

		return {
			winning_pitcher: (exists(game.winning_pitcher)) ? new GameMiniscoreboardOffense(game.winning_pitcher) : null,
			losing_pitcher: (exists(game.losing_pitcher)) ? new GameMiniscoreboardOffense(game.losing_pitcher) : null,
			save_pitcher: (exists(game.save_pitcher)) ? new GameMiniscoreboardOffense(game.save_pitcher) : null,
			home_wins: (exists(game.home_team)) ? game.home_team.wins || "" : "",
			home_losses: (exists(game.home_team)) ? game.home_team.losses || "" : "",
			away_wins: (exists(game.away_team)) ? game.away_team.wins || "" : "",
			away_losses: (exists(game.away_team)) ? game.away_team.losses || "" : ""
		}
	}

	function parseHomeRuns($runs) {
		var runners = (exists($runs, "player")) ? [].concat($runs.player) : [],
			homeRunners = [],
			GameMiniscoreboardOffense = require('./GameMiniscoreboardOffense');

		for (var i = 0, len = runners.length; i < len; i++) {
			homeRunners[i] = new GameMiniscoreboardOffense(runners[i]);
		}

		return homeRunners;
	}

	return GameMiniscoreboard;
});
